<template lang="pug">
  .auth--oauth
    Login(
      v-if="login"
      @logged="loginUser")

    Oauth(
      :serviceId="serviceId"
      @authorize="authorizeApp"
      v-if="oauth")

    //- Fails login with Oauth
    .text--center(v-if="generalError")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}


    .text--center(v-if="oauthClientError")
      van-icon(name="error")
      h1 {{ $t('errors.clientNotExist.title')}}
      p {{ $t('errors.clientNotExist.message')}}

    //- Fails authorize App
    .text--center(v-if="authorizeError")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}
</template>

<script>
import i18n from '@/locales/i18n';
import axios from 'axios';
import UserService from '@/services/user.service';
import Login from '@/components/Login.component.vue';
import Oauth from '@/components/Oauth.component.vue';
// import { PROYECT } from '@/constant';

export default {
  components: { Login, Oauth },
  data() {
    return {
      user: null,
      login: false,
      oauth: false,
      serviceId: '',
      oauthData: null,
      oauthClientError: false,
      authorizeError: false,
      generalError: false,
    };
  },
  methods: {
    // eslint-disable-next-line
    getParamURI(pageURL, sParam) {
      const splitPageURL = pageURL.split('?');
      const sPageURL = splitPageURL[1];
      const sURLVariables = sPageURL.split('&');
      let sParameterName = null;

      for (let i = 0; i < sURLVariables.length; i += 1) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    },

    /*
     * User has been logged success
     */
    loginUser(user) {
      console.log('Usuario', user);
      this.user = user;
      this.login = false;
      // window.localStorage.setItem('token', `Bearer ${user.token}`);
      // axios.defaults.headers.common.Authorization = `Bearer ${user.token}`;

      this.oauthLogin();
    },

    /*
     * Update User Data when user data is in local Storage
     */
    async updateUserData() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: i18n.t('general.loading'),
      });

      try {
        const user = await UserService.isLogin();
        this.user = user.data;

        this.$toast.clear();

        this.oauthLogin();
      } catch (error) {
        this.$toast.clear();

        this.login = true;
      }
    },

    /*
     * Login with Oauth
     */
    oauthLogin() {
      try {
        // eslint-disable-next-line
        const pageURL = window.location.href;
        const clientId = this.getParamURI(pageURL, 'client_id');

        console.log('Client ID', clientId);

        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        console.log('Petición authorize');
        axios
          .get('users/oauth2/authorize', { params: { client_id: clientId } })
          .then(oauthData => {
            const service = oauthData.data.name;
            let serviceId = '';

            if (service.includes('alexa')) serviceId = 'ALEXA';
            if (service.includes('google')) serviceId = 'GOOGLE';
            if (service.includes('ifttt')) serviceId = 'IFTTT';
            if (service.includes('openapi')) serviceId = 'OPENAPI';

            if (serviceId === '') {
              this.oauthClientError = true;
            } else {
              console.log('Datos obtenidos', oauthData);
              this.oauthData = oauthData.data;
              this.serviceId = serviceId;
              this.$toast.clear();
              this.oauth = true;
            }
          })
          .catch(error => {
            if (
              error.response &&
              error.response.data &&
              (error.response.data._id === 'getOauth2Info' ||
                error.response.data._id === 'oauth2EntityNotExist')
            ) {
              this.oauthClientError = true;
            } else {
              this.generalError = true;
            }

            this.oauth = false;
            this.$toast.clear();
          });
      } catch (error) {
        this.generalError = true;
        this.oauth = false;
        this.$toast.clear();
      }
    },

    /*
     * Authorize App
     */
    authorizeApp() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: i18n.t('general.loading'),
      });

      try {
        const pageURL = window.location.href;
        /* prettier-ignore */
        const paramsURL = new URLSearchParams(window.location.search.substring(1));
        const data = {
          entityName: this.oauthData.name,
          scopes: this.oauthData.scopes,
          state: this.getParamURI(pageURL, 'state'),
          client_id: this.getParamURI(pageURL, 'client_id'),
          redirect_uri: paramsURL.get('redirect_uri'),
        };

        axios
          .post('users/oauth2/authorize', data)
          .then(response => {
            this.oauth = false;
            window.location.href = response.data.redirectUri;
            this.$toast.clear();
          })
          .catch(error => {
            if (
              error.response &&
              error.response.data &&
              (error.response.data._id === 'getOauth2Info' ||
                error.response.data._id === 'oauth2EntityNotExist')
            ) {
              this.oauthClientError = true;
            } else {
              this.generalError = true;
            }

            this.oauth = false;
            this.$toast.clear();
          });
      } catch (error) {
        this.generalError = true;
        this.oauth = false;
        this.$toast.clear();
      }
    },
  },

  created() {
    /*
     * DKN USA no tiene habilitada esta funcionalidad,
     * si alguien llega aquí lo redirijo al home
     */
    // if (PROYECT.HOST === "dknUsa") {
    //   router.push({ name: "home" });
    // }

    const token = window.localStorage.getItem('token');
    console.log(token);
    if (token === null) {
      this.login = true;
    } else {
      this.updateUserData();
    }
  },
};
</script>
